import { Extension } from '@tiptap/core';

export const EnhancedTaskListShortcuts = Extension.create({
  name: 'enhancedTaskListShortcuts',

  addKeyboardShortcuts() {
    return {
      // Cmd/Ctrl + Shift + L: Toggle task list
      'Mod-Shift-l': () => this.editor.commands.toggleTaskList(),

      // Tab: Indent task item (nest deeper)
      'Tab': () => {
        const { state } = this.editor;
        const { $from } = state.selection;

        // Check if we're in a task item
        if ($from.parent.type.name === 'taskItem') {
          return this.editor.commands.sinkListItem('taskItem');
        }

        return false;
      },

      // Shift + Tab: Unindent task item (nest shallower)
      'Shift-Tab': () => {
        const { state } = this.editor;
        const { $from } = state.selection;

        // Check if we're in a task item
        if ($from.parent.type.name === 'taskItem') {
          return this.editor.commands.liftListItem('taskItem');
        }

        return false;
      },

      // Enter: Smart enter behavior for task lists
      'Enter': () => {
        const { state } = this.editor;
        const { $from } = state.selection;

        // Check if we're in a task item
        if ($from.parent.type.name === 'taskItem') {
          // If the task item is empty, lift it out of the task list
          if ($from.parent.textContent.trim() === '') {
            return this.editor.commands.liftListItem('taskItem');
          }

          // Otherwise, create a new task item
          return this.editor.commands.splitListItem('taskItem');
        }

        return false;
      },

      // Cmd/Ctrl + Enter: Toggle current task item checked state
      'Mod-Enter': () => {
        const { state } = this.editor;
        const { $from } = state.selection;

        // Check if we're in a task item
        if ($from.parent.type.name === 'taskItem') {
          const currentChecked = $from.parent.attrs.checked || false;

          return this.editor.commands.updateAttributes('taskItem', {
            checked: !currentChecked,
          });
        }

        return false;
      },

      // Backspace: Smart backspace behavior
      'Backspace': () => {
        const { state } = this.editor;
        const { $from, empty } = state.selection;

        // Only handle if selection is empty and at the start of a task item
        if (empty && $from.parentOffset === 0 && $from.parent.type.name === 'taskItem') {
          // If the task item is empty, remove it and lift out
          if ($from.parent.textContent.trim() === '') {
            return this.editor.commands.liftListItem('taskItem');
          }
        }

        return false;
      },
    };
  },
});